<template>
  <div style="min-height: 100vh;" :class="user ? 'custPersonalAccount' : 'custPersonalAccount public-page'">
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/all.min.css">
    <!-- <link rel="stylesheet" media="all" type="text/css" href="../../static/front/responsive_style.css"> -->
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/style.css">
    <link rel="stylesheet" media="all" type="text/css" href="../../static/front/custom_style.css">
    <HeaderBusiness v-if="!['purchase-token', 'upgrade-membership', 'profile-upgrade-membership', 'billing-token-mobile'].includes($route.name)"></HeaderBusiness>
    <div>
      <router-view name="business"></router-view>
    </div>
    <FooterBusiness v-if="!['purchase-token', 'upgrade-membership', 'profile-upgrade-membership', 'billing-token-mobile'].includes($route.name)"></FooterBusiness>
  </div>
</template>

<script>
import Vue from 'vue'
import store from '../store'
import HeaderBusiness from '../components/business/Header.vue'
import FooterBusiness from '../components/business/Footer.vue'
import VueHead from 'vue-head'
Vue.use(VueHead)

export default {
  // head: {
  //   link: [
  //     {rel: 'stylesheet', href: '/static/front/bootstrap/dist/css/bootstrap.min.css'}
  //   ]
  // },
  data () {
    return {
      user: (store.getters.currentUser) ? store.getters.currentUser : null
    }
  },
  components: {HeaderBusiness, FooterBusiness}
}
</script>

<style scoped>
  .page-container {
    min-height: 100vh;
  }
  .public-page .blue-footer  {
    margin-top: 0px;
  }

  .page-content {
    min-width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/BusinessPanel.vue